import React, { useState, useEffect } from "react";
import { IP } from "../configuracion.js";
import "../styles/Kioscos.css";

const Kioscos = ({ deviceConfig, currentUser, onLogout, property }) => {
  console.log("=== KIOSCOS COMPONENT MOUNTED ===");
  console.log("Props recibidas:", { property, deviceConfig, currentUser });

  const [order, setOrder] = useState([]);
  const [products, setProducts] = useState([]);
  const [groups, setGroups] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [chequeSeleccionado, setChequeSeleccionado] = useState(null);
  const [mensaje, setMensaje] = useState(null);
  const [revenues, setRevenues] = useState([]);
  const [apiConfig, setApiConfig] = useState({ API_PAGO: "", API_PEDIDO: "" });

  const baseUrl = `${IP}/tavpos/backend`;

  // DEBUG: Mostrar props recibidas
  useEffect(() => {
    console.log("=== KIOSCOS DEBUG EFFECT ===");
    console.log("property desde prop:", property);
    console.log("deviceConfig:", deviceConfig);
    console.log("deviceConfig.Depto:", deviceConfig?.Depto);
    console.log("currentUser:", currentUser);
  }, [property, deviceConfig, currentUser]);

  // Función para mostrar mensajes temporales
  const mostrarMensaje = (texto, duracion = 3000) => {
    setMensaje(texto);
    setTimeout(() => setMensaje(null), duracion);
  };

  // Cargar configuración de la API
  useEffect(() => {
    const loadApiConfig = async () => {
      if (!property) {
        console.warn("❌ Property no definida en loadApiConfig");
        return;
      }

      try {
        console.log(`🔧 Cargando config para property: ${property}`);
        const response = await fetch(`${baseUrl}/data/${property}/config.json`);
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const config = await response.json();
        setApiConfig({
          API_PAGO: `${baseUrl}/pagos.php`,
          API_PEDIDO: `${baseUrl}/insertar_pedido.php`,
        });
        console.log("✅ Configuración de API cargada");
      } catch (error) {
        console.error(`❌ Error cargando config de ${property}:`, error);
        mostrarMensaje(`Error al cargar configuración de ${property}. Usando valores por defecto.`);
        setApiConfig({
          API_PAGO: `${baseUrl}/pagos.php`,
          API_PEDIDO: `${baseUrl}/insertar_pedido.php`,
        });
      }
    };

    if (property) {
      loadApiConfig();
    }
  }, [property, baseUrl]);

  // Cargar revenues
  useEffect(() => {
    const loadRevenues = async () => {
      if (!property) {
        console.warn("❌ Property no definida en loadRevenues");
        return;
      }

      try {
        console.log(`🔧 Cargando revenues para property: ${property}`);
        const response = await fetch(`${baseUrl}/data/${property}/revenues.json`);
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const data = await response.json();
        const revenuesData = Array.isArray(data) ? data : data.revenues || [];
        setRevenues(revenuesData);
        console.log(`✅ Revenues cargados: ${revenuesData.length} centros de consumo`);
      } catch (error) {
        console.error(`❌ Error cargando revenues de ${property}:`, error);
        mostrarMensaje("Error al cargar centros de consumo.");
        setRevenues([]);
      }
    };

    if (property) {
      loadRevenues();
    }
  }, [property, baseUrl]);

  // Cargar productos - CON VERIFICACIONES MÁS ESTRICTAS
  useEffect(() => {
    const loadProducts = async () => {
      console.log("=== 🚀 INICIANDO CARGA DE PRODUCTOS ===");
      
      // Verificaciones estrictas
      if (!property) {
        console.error("❌ Property es null/undefined");
        mostrarMensaje("Error: Property no definida");
        setLoading(false);
        return;
      }

      if (!deviceConfig?.Depto) {
        console.error("❌ deviceConfig.Depto es null/undefined", deviceConfig);
        mostrarMensaje("Error: Departamento del dispositivo no definido");
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const deptId = deviceConfig.Depto.toString().replace("_", "");
        console.log("📋 Datos para carga:");
        console.log("   Property:", property);
        console.log("   Depto ID:", deptId);
        console.log("   Device:", deviceConfig.name);

        const productsUrl = `${baseUrl}/data/${property}/products_${deptId}.json`;
        console.log("🌐 URL de productos:", productsUrl);

        console.log("⏳ Realizando fetch...");
        const response = await fetch(productsUrl);
        console.log("📡 Response status:", response.status, response.statusText);

        if (!response.ok) {
          throw new Error(`HTTP ${response.status} - No se pudo cargar ${productsUrl}`);
        }
        
        const data = await response.json();
        console.log("📦 Datos crudos recibidos:", data);

        // ESTRATEGIAS DE EXTRACCIÓN DE PRODUCTOS
        let productsArray = [];
        const dynamicKey = `products_${deptId}`;
        
        if (data[dynamicKey] && Array.isArray(data[dynamicKey])) {
          productsArray = data[dynamicKey];
          console.log(`✅ Productos encontrados en '${dynamicKey}': ${productsArray.length}`);
        } 
        else if (data.products && Array.isArray(data.products)) {
          productsArray = data.products;
          console.log(`✅ Productos encontrados en 'products': ${productsArray.length}`);
        }
        else if (Array.isArray(data)) {
          productsArray = data;
          console.log(`✅ Productos encontrados como array directo: ${productsArray.length}`);
        }
        else {
          console.warn("❌ No se encontró estructura de productos conocida");
          console.warn("Estructuras disponibles:", Object.keys(data));
          // Intentar con la primera propiedad que sea array
          const arrayKeys = Object.keys(data).filter(key => Array.isArray(data[key]));
          if (arrayKeys.length > 0) {
            productsArray = data[arrayKeys[0]];
            console.log(`⚠️ Productos encontrados en '${arrayKeys[0]}': ${productsArray.length}`);
          }
        }

        // VERIFICACIÓN FINAL
        if (!Array.isArray(productsArray) || productsArray.length === 0) {
          console.error("❌ Array de productos vacío o inválido");
          mostrarMensaje(`No se encontraron productos para el departamento ${deptId}.`);
          setProducts([]);
          setGroups([]);
          setLoading(false);
          return;
        }

        console.log(`🎯 ${productsArray.length} productos cargados exitosamente`);

        // PROCESAR GRUPOS Y CATEGORÍAS
        const allGroups = productsArray.map(p => p.group).filter(Boolean);
        const uniqueGroups = [...new Set(allGroups)];
        
        console.log("📊 Grupos encontrados:", uniqueGroups);
        console.log("📈 Distribución de grupos:", allGroups.reduce((acc, group) => {
          acc[group] = (acc[group] || 0) + 1;
          return acc;
        }, {}));

        const groupsWithCategories = uniqueGroups.map((group) => ({
          name: group,
          categories: [...new Set(
            productsArray
              .filter((p) => p.group === group && p.category)
              .map((p) => p.category)
          )].filter(Boolean)
        }));

        console.log("📋 Grupos con categorías:", groupsWithCategories);

        setProducts(productsArray);
        setGroups(groupsWithCategories);

        // SELECCIÓN INICIAL
        if (uniqueGroups.length > 0) {
          const firstGroup = uniqueGroups[0];
          setSelectedGroup(firstGroup);
          
          const firstGroupCategories = groupsWithCategories.find(g => g.name === firstGroup)?.categories || [];
          if (firstGroupCategories.length > 0) {
            setSelectedCategory(firstGroupCategories[0]);
            console.log(`📍 Seleccionado: Grupo '${firstGroup}', Categoría '${firstGroupCategories[0]}'`);
          } else {
            setSelectedCategory(null);
            console.log(`📍 Seleccionado: Grupo '${firstGroup}' (sin categorías)`);
          }
        } else {
          console.warn("⚠️ No hay grupos disponibles");
          mostrarMensaje("No se encontraron grupos de productos.");
        }

        console.log("=== ✅ CARGA DE PRODUCTOS COMPLETADA ===");

      } catch (error) {
        console.error("❌ Error crítico cargando productos:", error);
        mostrarMensaje(`Error al cargar productos: ${error.message}`);
        setProducts([]);
        setGroups([]);
      } finally {
        setLoading(false);
      }
    };

    // Solo cargar si tenemos todos los datos necesarios
    if (property && deviceConfig?.Depto) {
      console.log("🎯 Condiciones cumplidas, iniciando carga de productos...");
      loadProducts();
    } else {
      console.warn("⏸️ Carga de productos pausada - faltan datos:", {
        property: !!property,
        deviceConfig: !!deviceConfig,
        depto: !!deviceConfig?.Depto
      });
      setLoading(false);
    }
  }, [deviceConfig?.Depto, property, baseUrl]);

  // Función para rutas de imágenes
  const getProductImagePath = (productName) => {
    if (!property) return `${process.env.PUBLIC_URL}/img/default_product.jpg`;
    
    const formattedName = productName
      .replace(/\s+/g, " ")
      .trim()
      .toLowerCase();
    return `${process.env.PUBLIC_URL}/img/${property}/${encodeURIComponent(formattedName)}`;
  };

  // Componente de imagen
  const ProductImage = ({ product }) => {
    const [imageSrc, setImageSrc] = useState(getProductImagePath(product.name));
    const [errorCount, setErrorCount] = useState(0);

    const handleImageError = () => {
      const extensions = ["webp", "jpg", "png"];
      if (errorCount < extensions.length) {
        setImageSrc(`${getProductImagePath(product.name)}.${extensions[errorCount]}`);
        setErrorCount((prev) => prev + 1);
      } else {
        setImageSrc(`${process.env.PUBLIC_URL}/img/${property}/default_product.jpg`);
        setErrorCount((prev) => prev + 1);
        if (errorCount >= extensions.length) {
          setImageSrc(`${process.env.PUBLIC_URL}/img/default_product.jpg`);
        }
      }
    };

    return (
      <img
        src={imageSrc}
        alt={product.name}
        onError={handleImageError}
        className="product-image"
        loading="lazy"
      />
    );
  };

  // Funciones para manejar el pedido
  const addToOrder = (product) => {
    setOrder((prev) => {
      const existing = prev.find((item) => item.id === product.id);
      if (existing) {
        return prev.map((item) =>
          item.id === product.id
            ? { ...item, quantity: item.quantity + 1 }
            : item
        );
      }
      return [...prev, { ...product, quantity: 1 }];
    });
  };

  const removeFromOrder = (productId) => {
    setOrder((prev) => prev.filter((item) => item.id !== productId));
  };

  const updateQuantity = (productId, quantity) => {
    setOrder((prev) =>
      prev.map((item) =>
        item.id === productId
          ? { ...item, quantity: Math.max(1, quantity) }
          : item
      )
    );
  };

  useEffect(() => {
    const newTotal = order.reduce(
      (sum, item) => sum + item.price * item.quantity,
      0
    );
    setTotal(newTotal);
  }, [order]);

  const handleFullOrder = async () => {
    try {
      const deptId = deviceConfig.Depto?.toString().replace("_", "");
      if (!deptId) {
        throw new Error("Departamento no definido en la configuración del dispositivo.");
      }

      const revenue = revenues.find((r) => r.id === parseInt(deptId, 10));
      if (!revenue) {
        throw new Error(`No se encontró un centro de consumo para el departamento ID ${deptId}`);
      }

      const fullOrderData = {
        deviceName: deviceConfig.name,
        accountNumber: 0,
        userId: currentUser?.id,
        userName: currentUser?.nombre,
        revenueId: revenue.id,
        revenueName: revenue.name,
        mesa: `${revenue.name} Order`,
        clientes: 1,
        clienteQuePidio: 1,
        order: order.map((p) => ({
          id: p.id,
          quantity: p.quantity,
          modifiers: p.modifiers || [],
          client: 0,
          price: p.price,
          tax: p.tax || 0,
          name: p.name,
          KDS: p.KDS || [],
        })),
        total: total,
      };

      const response = await fetch(`${apiConfig.API_PEDIDO}?property=${encodeURIComponent(property)}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(fullOrderData),
      });

      const result = await response.json();
      if (!result.success) {
        throw new Error(result.message || "Error al procesar el pedido");
      }

      setChequeSeleccionado(result.data.numero_cheque);
      return result.data.numero_cheque;
    } catch (error) {
      console.error("Error al procesar el pedido completo:", error);
      throw error;
    }
  };

  const handlePaymentAndConfirm = async () => {
    if (order.length === 0) {
      mostrarMensaje("No hay productos en el pedido.");
      return;
    }

    try {
      let numeroCheque = chequeSeleccionado;
      if (!numeroCheque) {
        numeroCheque = await handleFullOrder();
        mostrarMensaje("Pedido enviado exitosamente.");
      }

      const paymentData = {
        numero_cheque: numeroCheque,
        total_pedido: total,
        total_pagado: total,
        pagos: [
          {
            id_pago: 10,
            nombre_pago: "CxC",
            monto_pagado: total,
            propina: 0,
            cambio: 0,
            folio: currentUser?.nombre || "Guest",
          },
        ],
      };

      const response = await fetch(`${apiConfig.API_PAGO}?property=${encodeURIComponent(property)}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(paymentData),
      });

      const responseData = await response.json();
      if (!response.ok || !responseData.success) {
        throw new Error(responseData.message || `Error HTTP ${response.status}`);
      }

      setOrder([]);
      setChequeSeleccionado(null);
      setTotal(0);
      setSelectedGroup(groups[0]?.name || null);
      setSelectedCategory(groups[0]?.categories[0] || null);
      mostrarMensaje(`✅ Pago confirmado! Cheque #${numeroCheque} cerrado.`);
      setTimeout(onLogout, 2000);
    } catch (error) {
      console.error("Error en handlePaymentAndConfirm:", error);
      mostrarMensaje(`❌ Error: ${error.message}`);
    }
  };

  // Filtrar productos
  const filteredProducts = selectedCategory 
    ? products.filter(p => p.group === selectedGroup && p.category === selectedCategory)
    : products.filter(p => p.group === selectedGroup);

  // DEBUG: Estado actual
  console.log("=== 🔄 RENDER KIOSCOS ===");
  console.log("Loading:", loading);
  console.log("Products:", products.length);
  console.log("Groups:", groups.length);
  console.log("Selected Group:", selectedGroup);
  console.log("Selected Category:", selectedCategory);
  console.log("Filtered Products:", filteredProducts.length);
  console.log("Order:", order.length);

  if (loading) {
    return (
      <div className="loading">
        <div>Loading menu...</div>
        <div className="debug-info">
          Property: {property || "No definida"} | 
          Depto: {deviceConfig?.Depto || "No definido"}
        </div>
      </div>
    );
  }

  return (
    <div className="kiosk-container">
      <header className="kiosk-header">
        <div className="header-content">
          <h1>{deviceConfig?.name || "Kiosco"} ({property || "Sin propiedad"}) - Depto: {deviceConfig?.Depto || "N/A"}</h1>
          <div className="user-info">
            <span className="welcome-text">Welcome, {currentUser?.nombre || "Guest"}</span>
            <button onClick={onLogout} className="logout-button">
              Logout
            </button>
          </div>
        </div>
      </header>

      <main className="kiosk-main">
        <section className="menu-section">
          {/* Grupos */}
          <div className="group-container">
            {groups.length > 0 ? (
              groups.map((group) => (
                <button
                  key={group.name}
                  className={`group-button ${selectedGroup === group.name ? "active" : ""}`}
                  onClick={() => {
                    setSelectedGroup(group.name);
                    setSelectedCategory(group.categories.length > 0 ? group.categories[0] : null);
                  }}
                >
                  {group.name}
                </button>
              ))
            ) : (
              <div className="no-groups">
                <p>No hay grupos disponibles</p>
                <p className="debug-info">
                  Products: {products.length} | Groups: {groups.length}
                </p>
              </div>
            )}
          </div>
          
          {/* Categorías */}
          {selectedGroup && groups.find(g => g.name === selectedGroup)?.categories.length > 0 && (
            <div className="category-container">
              {groups
                .find((g) => g.name === selectedGroup)
                ?.categories.map((category) => (
                  <button
                    key={category}
                    className={`category-button ${selectedCategory === category ? "active" : ""}`}
                    onClick={() => setSelectedCategory(category)}
                  >
                    {category}
                  </button>
                ))}
            </div>
          )}

          {/* Productos */}
          <div className="menu-items">
            {filteredProducts.length === 0 ? (
              <div className="no-products">
                <p>No items available in {selectedGroup} {selectedCategory ? `- ${selectedCategory}` : ''}</p>
                <div className="debug-info">
                  <p>Total Products: {products.length}</p>
                  <p>Groups: {groups.length}</p>
                  <p>Selected: {selectedGroup} / {selectedCategory || 'All'}</p>
                  <p>Property: {property}</p>
                  <p>Depto: {deviceConfig?.Depto}</p>
                </div>
              </div>
            ) : (
              filteredProducts.map((product) => (
                <div
                  key={product.id}
                  className="menu-item"
                  onClick={() => addToOrder(product)}
                >
                  <ProductImage product={product} />
                  <div className="item-details">
                    <h3>{product.name}</h3>
                    <p>${typeof product.price === 'number' ? product.price.toFixed(2) : '0.00'}</p>
                  </div>
                </div>
              ))
            )}
          </div>
        </section>

        <aside className="order-section">
          <h2>Your Order</h2>
          {mensaje && <div className="mensaje">{mensaje}</div>}
          {order.length === 0 ? (
            <p className="empty-order">No items in order</p>
          ) : (
            <>
              <div className="order-items">
                {order.map((item) => (
                  <div key={item.id} className="order-item">
                    <div className="item-info">
                      <span className="item-name">{item.name}</span>
                      <span className="item-price">
                        ${(item.price * item.quantity).toFixed(2)}
                      </span>
                    </div>
                    <div className="quantity-controls">
                      <button
                        onClick={() => updateQuantity(item.id, item.quantity - 1)}
                      >
                        -
                      </button>
                      <span>{item.quantity}</span>
                      <button
                        onClick={() => updateQuantity(item.id, item.quantity + 1)}
                      >
                        +
                      </button>
                      <button
                        className="remove-button"
                        onClick={() => removeFromOrder(item.id)}
                      >
                        ×
                      </button>
                    </div>
                  </div>
                ))}
              </div>
              <div className="order-footer">
                <div className="order-total">
                  <span>Total:</span>
                  <span>${total.toFixed(2)}</span>
                </div>
                <button
                  onClick={handlePaymentAndConfirm}
                  disabled={order.length === 0}
                  className="pay-button"
                >
                  Pay Now
                </button>
              </div>
            </>
          )}
        </aside>
      </main>
    </div>
  );
};

export default Kioscos;